import { ValueState } from "sap/ui/core/library";
import { ConfirmDialogData } from "../models/ConfirmDialogData";
import { SpecificationStatus } from "../models/SpecificationStatuses";

export default function GetSpecificationChangeStatusDialogData(
  newStatus: SpecificationStatus
): ConfirmDialogData {
  switch (newStatus) {
    case "cancelled":
      return {
        title: "cancelledSpecification",
        message: "cancelledSpecificationQuestion",
        dialogState: ValueState.Error,
      };
    case "closed":
      return {
        title: "closedSpecification",
        message: "closedSpecificationQuestion",
        dialogState: ValueState.Success,
      };
    case "finished":
      return {
        title: "finishedSpecification",
        message: "finishedSpecificationQuestion",
        dialogState: ValueState.Warning,
      };
    case "draft":
      return {
        title: "draftSpecification",
        message: "draftSpecificationQuestion",
        dialogState: ValueState.Information,
      };
    default:
      return {
        title: "statusNotFound",
        message: "statusNotFoundMessage",
        dialogState: ValueState.Error,
      };
  }
}
